module.exports = function(dispatcher) {
  return function(initials, absoluteParent) {
    dispatcher.dispatch({
      type: 'storeInitials',
      initials,
      absoluteParent
    });
  };
};
